import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { ResponseData } from '../interface/response';
import { AppConstant, RESPONSE_CODE, VALIDATOR_PATTERNS } from './app-constant';

export function convertDate(data: any): Date | any {
  const dat = new Date(data);
  return `${dat.getFullYear()}-${dat.getMonth() + 1}-${dat.getDate()}`;
}
export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export function replaceBracesWithValues(
  input: string,
  replacementObj: Record<string, string | number>
): string {
  return input.replace(/\{([^}]+)\}/g, (match, key) =>
    String(replacementObj[key.trim()] || match)
  );
}

export function createSearchTableQuery(event: any) {
  if (!event) return null;

  const search: any = {};
  let sortText;
  const rows = event.rows || AppConstant.TABLE_PAGE_ROWS;
  if (event.first) search.page = event.first / rows;
  else search.page = 0;
  search.rows = event.rows;
  if (event.filters) {
    search.queryParams = [];
    Object.keys(event.filters).forEach((key) => {
      const d = event.filters[key].value || '';
      if (d instanceof Date) {
        event.filters[key].value = `${d.getFullYear()}-${
          d.getMonth() + 1
        }-${d.getDate()}`;
        event.filters[key].type = 'DATE';
      } else if (typeof d == 'object') {
        event.filters[key].value = null;
      }
      event.filters[key]['colName'] = key;
      if (event.filters[key].value) {
        search.queryParams.push(event.filters[key]);
      }
    });
  }
  if (event.sortField) {
    search.sort = [];
    if (event.sortOrder == 1) {
      sortText = 'asc';
    } else if (event.sortOrder == -1) {
      sortText = 'desc';
    }
    if (event.sortField) {
      search.sort.push({ colName: event.sortField, sortOrder: sortText });
    }
  }
  return search;
}

export function extractNumber(txt: string | number) {
  return +String(txt).replace(/\D/g, '');
}
export function isNumber(value: string | number): boolean {
  if (typeof value === 'number') {
    return !isNaN(value); // Always true for valid numbers
  } else if (typeof value === 'string') {
    return /^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(value.trim());
  }
  return false;
}

export function toMonthName(
  monthNumber: number = new Date().getMonth() + 1,
  type: 'short' | 'long' = 'short'
): string {
  // Ensure monthNumber is between 1 and 12
  if (monthNumber < 1 || monthNumber > 12) {
    throw new Error('Month number must be between 1 and 12');
  }
  // Create a new Date object for the desired month
  const date = new Date();
  date.setMonth(monthNumber - 1); // Set month (adjust for zero-based index)

  // Return month name based on the 'type' parameter
  return date.toLocaleString('en-US', { month: type });
}

export function isArray(data: any) {
  if (Array.isArray(data)) {
    return data.length;
  }
  return false;
}

export function cleanForm(formGroup: UntypedFormGroup): any {
  Object.keys(formGroup.controls).forEach((key) => {
    if (formGroup.get(key)?.asyncValidator?.length) {
      return;
    }
    if (
      formGroup.get(key)?.value &&
      typeof formGroup.get(key)?.value == 'string'
    )
      formGroup.get(key)?.setValue(formGroup.get(key)?.value?.trim());
  });
}

export function formToWhere(
  formValue,
  keys: Array<string> = [],
  skipNull = false
): Array<any> {
  const keyC = isArray(keys) ? keys : Object.keys(formValue),
    w: any = [];
  keyC.forEach((a) => {
    if (skipNull && formValue?.[a]) {
      w.push({ colName: a, value: formValue[a] });
    } else if (!skipNull) {
      w.push({ colName: a, value: formValue[a] });
    }
  });
  return w;
}

export function filterData(filters: any, data: any): any {
  if (!filters) return [];
  let keys: any = Object.keys(filters);
  return data.filter((item: any) => {
    return keys.every((key: any) => {
      if (typeof filters[key] !== 'function') return true;
      return filters[key](item[key]);
    });
  });
}

export function isEmailUniqueValidation(
  control: AbstractControl
): Promise<any> | Observable<any> {
  //@ts-ignore
  const self = this;
  let regx =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const promise = new Promise<any>((resolve, reject) => {
    if (self.email_id && self.email_id == control.value) {
      resolve(null);
    }
    self.emailCheckingloading = false;
    if (control.value && control.value.match(regx) !== null) {
      self.userApi
        .isUnique('user_name', control.value)
        .then((data: ResponseData) => {
          resolve(data.result);
          // if (!data.result.length) {
          //   resolve(null);
          // } else {
          //   resolve({ isNotUnique: true });
          // }
        })
        .catch((error: any) => {
          resolve({ isNotUnique: true });
        })
        .finally(() => {
          self.emailCheckingloading = false;
        });
    } else {
      resolve(null);
    }
  });
  return promise;
}

export function isMobileUniqueValidation(
  control: AbstractControl
): Promise<any> | Observable<any> {
  //@ts-ignore
  const self = this,
    formValue = control.parent?.value,
    skipVal = formValue.staff_emp_id;
  // const code = control.parent?.value?.country_code || '91';
  const phone = control.value;
  let regx = VALIDATOR_PATTERNS.MOBILE;
  const promise = new Promise<any>((resolve, reject) => {
    if (self.mobile_no && self.mobile_no == control.value) {
      resolve(null);
    }
    self.mobileCheckingloading = false;
    if (control.value && control.value.match(regx) !== null) {
      self.userApi
        .isMobileUnique(phone, skipVal)
        .then((data: ResponseData) => {
          if (data.statusCode == RESPONSE_CODE.SUCCESS) {
            resolve(data.result);
            //   const r = data?.result;
            //   resolve(!r ? { isNotUnique: !r } : null);
            // } else {
            //   resolve({ isNotUnique: true });
          }
        })
        .catch((error: any) => {
          resolve({ isNotUnique: true });
        })
        .finally(() => {
          self.mobileCheckingloading = false;
        });
    } else {
      resolve(null);
    }
  });
  return promise;
}

export function conditionalValidator(predicate: any, validator: any) {
  return (formControl: any) => {
    if (!formControl.parent) {
      return null;
    }
    if (predicate()) {
      return validator(formControl);
    }
    return null;
  };
}

export function removeTableClass(elRef: any) {
  let el = elRef.nativeElement.querySelectorAll('.table-responsive div');
  el.forEach((cl: any) => {
    cl.classList.remove('ui-table-wrapper');
    cl.classList.remove('ui-table');
    cl.classList.remove('ui-widget');
    cl.classList.remove('ui-table-responsive');
    cl.classList.remove('ui-table-auto-layout');
    cl.classList.remove('ui-table-resizable');
    cl.classList.remove('ui-widget-header');
    cl.classList.remove('ui-table-thead');
  });
}

export function decryptData(data: any) {
  return data;
}

export function encryptData(data: any) {
  if (data === '') return;
  data = data.toString();
  return data;
}

export function isEmptyObj(obj: any) {
  if (obj && typeof obj === 'object') {
    return Object.getOwnPropertyNames(obj).length == 0;
  } else {
    return true;
  }
}

export function cloneData(data: any) {
  return structuredClone(data);
}
export function queryToString(ev: any) {
  return isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
}
export function jsonParse(str: any) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}
export function isExistsKey(obj: any, props: string[]): boolean {
  return props.every((prop) => {
    if (!obj || !obj.hasOwnProperty(prop)) return false;
    obj = obj[prop];
    return true;
  });
}
export function uniqueArray(a: any) {
  return a.filter(function (i: any, p: any) {
    return a.indexOf(i) == p;
  });
}

export function sort(arr: any, prop: string, desc?: boolean) {
  arr.sort(function (a: any, b: any) {
    if (!a[prop]) return -1;
    return a[prop].localeCompare(b[prop], 'en', { ignorePunctuation: true });
  });
  if (desc) arr.reverse();
  return arr;
}

export function arrayGroupBy(xs: any, f: any) {
  return xs.reduce(
    (r: any, v: any, i: any, a: any, k = f(v)) => (
      (r[k] || (r[k] = [])).push(v), r
    ),
    {}
  );
}
export function randomString(len: number, charSet = '') {
  charSet =
    charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';
  for (let i = 0; i < len; i++) {
    let randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz + 1);
  }
  return randomString;
}

export function mysqlDataTime(
  fdate: any = new Date(),
  type: 'DATE' | 'DATETIME' = 'DATETIME'
) {
  if (!fdate) return '';
  const d = fdate instanceof Date ? fdate : new Date(fdate);
  const month = fdate instanceof Date ? d.getMonth() + 1 : d.getMonth();
  return type == 'DATE'
    ? `${d.getFullYear()}-${month}-${d.getDate()}`
    : `${d.getFullYear()}-${month}-${d.getDate()} ${d.getHours()}:${d.getMinutes()}`;
}

export function isValidUrl(url: any) {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
}
export function isPastDate(date: any): boolean {
  date = date instanceof Date ? +date : +new Date(date);
  const cDate = +new Date();
  return cDate > date;
}

export function betweenTwoDays(fromDate: any, toDate: any) {
  fromDate = fromDate instanceof Date ? fromDate : new Date(fromDate);
  toDate = toDate instanceof Date ? toDate : new Date(toDate);
  const timeDiff = toDate.getTime() - fromDate.getTime();
  const res = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  return Math.abs(res);
}

export function dateDifference(startDate: any, endDate: any) {
  startDate = startDate instanceof Date ? startDate : new Date(startDate);
  endDate = endDate instanceof Date ? endDate : new Date(endDate);
  const diffTime = Math.abs(startDate - endDate),
    diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}
export function getMonthLastDate(date: any) {
  date = date instanceof Date ? date : new Date(date);
  const lastDay = new Date(
    date.getFullYear(),
    date.getMonth() + 1,
    0
  ).getDate();
  date.setDate(lastDay);
  return date;
}
export function getLastMonth() {
  const currentDate = new Date();

  // Get the month and year of the current date
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  // Calculate the month and year of the previous month
  let previousMonth = currentMonth - 1;
  let previousYear = currentYear;

  if (previousMonth < 0) {
    // If the previous month is negative, subtract 1 from the year and set the month to 11 (December)
    previousMonth = 12;
    previousYear -= 1;
  }
  // Create a new Date object for the first day of the previous month
  return new Date(previousYear, previousMonth, 1);
}

export function getAllMonthArray() {
  const months: any = [];
  for (let i = 0; i < 12; i++) {
    const date = new Date(2000, i, 1);
    const monthName = date.toLocaleString('default', { month: 'short' });
    months.push({ label: monthName, key: i + 1 });
  }
  return months;
}

export function capitalizeWord(str: string) {
  return str.replace(/\b\w/g, (letter) => letter.toUpperCase());
}
export function toWordStringFirstCap(key) {
  return key
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/(?: |\b)(\w)/g, function (key, p1) {
      return key.toUpperCase();
    });
}
export function transformTitle(str: string = '') {
  if (typeof str !== 'string') {
    return str; // return non-strings (number, boolean, object, etc.) as-is
  }
  //fileName => file Name , zon_name=> Zon Name
  return (str || '')
    ?.replace(/\_+/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camel case words
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
  // return toWordStringFirstCap(str?.replace(/\_+/g, ' ').replace(/\b\w/g, char => char.toUpperCase()) || '');
}
export function mergeArraysByKey(arr1, arr2, key) {
  arr2.forEach((ar2: any) => {
    const index: any = arr1.findIndex((item) => item[key] === ar2[key]);
    arr1[index] = ar2;
  });
  return arr1;
}

export function sumByKey(arr, key) {
  return arr.reduce((acc, obj) => acc + +obj[key], 0);
}
export function getFinancialYear(date: Date = new Date()): Date {
  date = dateInstance(date);
  const year =
    date.getMonth() + 1 > 3 ? date.getFullYear() : date.getFullYear() - 1;
  return new Date(`${year}-04-01`);
}

export function dateInstance(date) {
  return date instanceof Date ? date : new Date(date);
}
export function replacePlaceholder(
  template: string,
  values: { [key: string]: string }
): string {
  return template.replace(/{(\w+)}/g, (match, key) => {
    return key in values ? values[key] : match; // Replace or keep the original match
  });
}
